/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Sign_Up_TitleInputs */

const en_app_sign_up_title = /** @type {(inputs: App_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up - AnyAPI`)
};

const zh_hans1_app_sign_up_title = /** @type {(inputs: App_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册 - AnyAPI`)
};

const pt_br2_app_sign_up_title = /** @type {(inputs: App_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadastro - AnyAPI`)
};

const es_app_sign_up_title = /** @type {(inputs: App_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear cuenta - AnyAPI`)
};

const fr_app_sign_up_title = /** @type {(inputs: App_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscription - AnyAPI`)
};

const de_app_sign_up_title = /** @type {(inputs: App_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrieren | AnyAPI`)
};

const ru_app_sign_up_title = /** @type {(inputs: App_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регистрация - AnyAPI`)
};

const it_app_sign_up_title = /** @type {(inputs: App_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrati - AnyAPI`)
};

/**
* | output |
* | --- |
* | "Sign up - AnyAPI" |
*
* @param {App_Sign_Up_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_sign_up_title = /** @type {((inputs?: App_Sign_Up_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Sign_Up_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_sign_up_title(inputs)
	if (locale === "pt-BR") return pt_br2_app_sign_up_title(inputs)
	if (locale === "es") return es_app_sign_up_title(inputs)
	if (locale === "fr") return fr_app_sign_up_title(inputs)
	if (locale === "de") return de_app_sign_up_title(inputs)
	if (locale === "ru") return ru_app_sign_up_title(inputs)
	if (locale === "it") return it_app_sign_up_title(inputs)
	return en_app_sign_up_title(inputs)
});